/**
 * @fileOverview This file contains the implementation of a toggle switch custom component
 * @version 1.0.0
 * @since 1.0.0
 * @author Santiago Cano Herrera
 */

//#region Imports
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

import variables from '../../scss/Components/Inventory/_movementmodal.scss';
//#endregion

// Switch container styles
const SwitchContainer = styled((props) => <div {...props} />)({
  width: '100%',
  height: '40px',
  backgroundColor: '#e0e0e0',
  borderRadius: '5px',
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  position: 'relative',
});

// Movable button styles
const SlidingButton = styled((props) => (
  <Button disableRipple variant='contained' {...props} />
))(({ active }) => ({
  width: '50%',
  height: '40px',
  borderRadius: '5px',
  transition: 'transform 0.3s ease',
  transform: active ? 'translateX(100%)' : 'translateX(0)',
  backgroundColor: active ? variables.redInv : variables.greenInv,
  color: 'white',
  zIndex: 1,
  position: 'absolute',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: active ? variables.redInv : variables.greenInv,
  },
  fontFamily: variables.robotoRegular,
  fontSize: '18px',
  boxShadow: 'none',
}));

const ToggleOption = ({ children }) => {
  return <>{children}</>;
};

const ToggleSwitch = ({
  divProps,
  buttonProps,
  isActive,
  onClick,
  children,
}) => {
  const handleClick = () => {
    onClick((prev) => !prev);
  };

  return (
    <SwitchContainer onClick={handleClick} {...divProps}>
      <SlidingButton active={!isActive} {...buttonProps}>
        {children[isActive ? 0 : 1]}
      </SlidingButton>
    </SwitchContainer>
  );
};

export { ToggleSwitch, ToggleOption };
